"use client"

import { ImageContainer } from "ui"
import { extractProperty } from "utils"

type Props = {
  data: any
}

function Parallax({ data }: Props) {
  const desktopImage = extractProperty(data, "desktopImage")
  const mobileImage = extractProperty(data, "mobileImage")
  return (
    <ImageContainer
      desktopUrl={desktopImage || mobileImage}
      mobileUrl={mobileImage || desktopImage}
      height={600}
      mediumHeight={360}
      mobileHeight={400}
      sm
      fill
    />
  )
}

export default Parallax
